import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_FORMDESIGN';

const en = {
    formDesign: 'Form Design',
    fields: 'Fields',
    actions: 'Actions',
    subforms: 'Subforms',
    restoreDefaults: 'Restore defaults',
    cancel: 'Cancel',
    save: 'Save',
    formDesignHeader: 'Form Design',
    beforeYouLeave: 'Before you leave',
    exitWithoutSaving: 'Exit without saving changes?',
    yes: 'Yes',
    no: 'No',
    searchField: 'Search field…',
    noResults: 'We did not find results for your search.',
    selectedCount: 'X selected',
    hide: 'Hide',
    hideField: 'Hide field',
    showField: 'Show field',
    rename: 'Rename',
    freezePane: 'Freeze pane',
    hidePackage: 'Hide package',
    showPackage: 'Show package',
    packageName: 'Package name',
    packageDescription: 'Package description',
    approveHidePackage: 'Are you sure you want hide the X package?',
    addTab: 'Add new tab',
    enterTabName: 'Enter a tab name...',
    moveTo: 'Move to',
    merge: 'Merge fields',
    searchAction: 'Search action…',
    split: 'Split fields',
    addSpace: 'Add space',
    removeSpace: 'Remove space',
    quickAccess: 'Quick Access',
    actionsList: 'Actions List',
    show: 'Show',
    showAction: 'Show action',
    searchSubform: 'Search subform…',
    freeze: 'Freeze',
    freezeWarn: 'You can freeze up to 5 fields.',
    unfreeze: 'Unfreeze',
    showImage: 'Show image',
    designWarn: 'There is not enough space to display the X field under the Y tab.',
    mandatoryFieldLimitWarn:
        'This is a mandatory field, and will not appear because you reached the field limit.',
    fieldLimitWarn: 'This field will not appear because you reached the field limit.',
    panels: 'Panels',
    unselect: 'Unselect',
    anotherTabWarn:
        'If you move to another tab, your changes will be lost. Save your changes first?',
    packagesDesign: 'Design by Package',
    invalidToast: 'The number of fields in this tab exceeds the limit.',
    moveToBottom: 'Move to bottom',
    moveDownOne: 'Move down one',
    moveUpOne: 'Move up one',
    moveToTop: 'Move to top',
    instructions: 'Cancel your current design and restore the default system design?',
    quickAccessHelp:
        'These two actions appear on your form header, instead of in the Actions list.\nWe recommend placing your most frequently used actions here.',
    actionsListHelp:
        'Here you can find the the list of Actions for this form.\nYou can rearrange them according to your needs, and place your two most frequently used actions in the %Quick Access% area above.'
};

const he = {
    formDesign: 'עיצוב מסך',
    fields: 'שדות',
    actions: 'פעולות',
    subforms: 'מסכי בן',
    restoreDefaults: 'איפוס הגדרות עיצוב',
    cancel: 'ביטול',
    save: 'שמירה',
    formDesignHeader: 'עיצוב מסך',
    beforeYouLeave: 'רגע לפני היציאה',
    exitWithoutSaving: 'האם לצאת בלי לשמור את השינויים?',
    yes: 'כן',
    no: 'לא',
    searchField: 'חיפוש שדה…',
    noResults: 'לא מצאנו תוצאות לחיפוש.',
    selectedCount: 'נבחרו X',
    hide: 'הסתרה',
    hideField: 'הסתרת שדה',
    showField: 'הצגת שדה',
    rename: 'שינוי שם',
    freezePane: 'הקפאת שדות',
    hidePackage: 'הסתרת חבילה',
    showPackage: 'הצגת חבילה',
    packageName: 'שם החבילה',
    packageDescription: 'תיאור החבילה',
    approveHidePackage: 'האם להסתיר את החבילה?',
    addTab: 'הוספת לשונית חדשה',
    enterTabName: 'רשמו שם ללשונית...',
    moveTo: 'העברה אל',
    merge: 'הצמדת שדות',
    searchAction: 'חיפוש פעולה...',
    split: 'הפרדת שדות',
    addSpace: 'הוספת רווח',
    removeSpace: 'ביטול רווח',
    quickAccess: 'גישה מהירה',
    actionsList: 'רשימת פעולות',
    show: 'הצגה',
    showAction: 'הצגת פעולה',
    searchSubform: 'חיפוש מסך בן…',
    freeze: 'הקפאה',
    freezeWarn: 'אפשר להקפיא עד 5 שדות.',
    unfreeze: 'ביטול הקפאה',
    showImage: 'הצגת תמונה',
    designWarn: 'בלשונית X אין מספיק מקום להציג את השדה Y.',
    mandatoryFieldLimitWarn: 'השדה X הוא שדה חובה, אך אין מספיק מקום להציגו.',
    fieldLimitWarn: 'אין מספיק מקום להציג את השדה X.',
    panels: 'כפתורים',
    unselect: 'ביטול בחירה',
    anotherTabWarn: 'עדיין לא שמרת את השינויים. להמשיך בכל זאת?',
    packagesDesign: 'עיצוב חבילות',
    invalidToast: 'הגעתם למספר השדות המקסימלי שאפשר להציג בלשונית זו.',
    moveToBottom: 'להזיז למיקום האחרון',
    moveDownOne: 'להזיז אחד למטה',
    moveUpOne: 'להזיז אחד למעלה',
    moveToTop: 'להזיז למיקום הראשון',
    instructions: 'האם לבטל את העיצוב הנוכחי ולשחזר את העיצוב המקורי?',
    quickAccessHelp:
        'שתי הפעולות שמופיעות בראש המסך (במקום ברשימת הפעולות).\nאנחנו ממליצים למקם כאן את שתי הפעולות בהן משתמשים הכי הרבה.',
    actionsListHelp:
        'זוהי רשימת הפעולות למסך. אפשר לשנות את סדר הפעולות ברשימה.\nמומלץ להעביר את שתי הפעולות העיקריות שלכם לאזור %גישה מהירה%.'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'formDesign',
    2: 'fields',
    3: 'actions',
    4: 'subforms',
    5: 'restoreDefaults',
    6: 'cancel',
    7: 'save',
    8: 'formDesignHeader',
    9: 'beforeYouLeave',
    10: 'exitWithoutSaving',
    11: 'yes',
    12: 'no',
    13: 'searchField',
    14: 'noResults',
    15: 'selectedCount',
    16: 'hide',
    17: 'hideField',
    18: 'showField',
    19: 'rename',
    20: 'freezePane',
    21: 'hidePackage',
    22: 'showPackage',
    23: 'packageName',
    24: 'packageDescription',
    25: 'approveHidePackage',
    26: 'addTab',
    27: 'enterTabName',
    28: 'moveTo',
    29: 'merge',
    30: 'searchAction',
    31: 'split',
    32: 'addSpace',
    33: 'removeSpace',
    34: 'quickAccess',
    35: 'actionsList',
    36: 'show',
    37: 'showAction',
    38: 'searchSubform',
    39: 'freeze',
    40: 'freezeWarn',
    41: 'unfreeze',
    42: 'showImage',
    43: 'designWarn',
    44: 'mandatoryFieldLimitWarn',
    45: 'fieldLimitWarn',
    46: 'panels',
    47: 'unselect',
    50: 'anotherTabWarn',
    51: 'invalidToast',
    53: 'packagesDesign',
    54: 'instructions',
    55: 'moveToBottom',
    56: 'moveDownOne',
    57: 'moveUpOne',
    58: 'moveToTop',
    59: 'quickAccessHelp',
    60: 'actionsListHelp'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
